import { TextInput } from "@/lib/Components/Form/Inputs/TextInput";
import { TextAreaInput } from "@/lib/Components/Form/Inputs/TextAreaInput";
import { useFormState } from "@/lib/Components/Form/Hooks/useFormState";
import { BlogAuthorInput } from "@/app/Blogs/Components/BlogAuthorInput";
import { CreateBlogPostInput } from "@/gql/graphql";
import { generateSlug } from "@/lib/Utils/string";
import { BlogAudienceInput } from "@/app/Blogs/Components/BlogAudienceInput";

export function BlogPostCreateForm() {
  const { touched, setFieldValue } = useFormState<CreateBlogPostInput>();

  return (
    <>
      <TextInput
        autoFocus
        name="title"
        label="Title"
        className="col-span-12"
        onChange={(val) => {
          if (!touched.slug) {
            setFieldValue("slug", val ? generateSlug(val) : "");
          }
        }}
      />

      <TextInput
        name="slug"
        label="Slug"
        className="col-span-8"
        description="Lowercase and dashes only"
      />

      <BlogAuthorInput
        name="blog_author_id"
        label="Author"
        className="col-span-4"
        clearable
      />

      <BlogAudienceInput
        name="audience"
        label="Audience"
        className="col-span-12"
      />

      <TextAreaInput
        name="excerpt"
        label="Excerpt"
        className="col-span-12"
        description="Short summary shown in the list view (optional)"
      />
    </>
  );
}
